import { BaseComponent } from '../../base-component';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class WarrantyComponent extends BaseComponent {
    public rootSelector = '.js_pdp_warranty';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const expanderElement = this.getChildElement<HTMLOcExpanderV1Element>('.js_pdp_warranty__label');
        expanderElement.addEventListener('ofc-warranty-label-sheet-open', () => this.handleSheetOpened());

        trackView({
            product_ExtendedWarranty: ['view'],
        });
    }

    private handleSheetOpened(): void {
        trackEvent({
            product_ExtendedWarranty: ['click'],
        });
    }
}
